import EventEmitter from '../../common/EventEmitter';
import { DiagnosticEvent, InternalEvents } from '../../events';
import { DiagnosticCode } from '../../api/diagnostics/constants';

export interface ECFailDiagArgs {
  message?: string;
  url: string;
  from: string;
  error?: unknown;
}

// Check CompositeError
// dispatchErrorIngest (check error name.)
// statusCode: WebrtcAgentInterceptor, status, responseText
// Error
// CloseEvent Event
// RequestError, ForbiddenError

// Send an event that will roll up with the error information, the url
const sendEdgeCacheFailureDiagnostic = (args: ECFailDiagArgs) => {
  const { url, error, from } = args;
  const event: DiagnosticEvent = {
    type: InternalEvents.DIAGNOSTIC,
    data: {
      error,
      data: { url },
      from,
      code: DiagnosticCode.FAILED_EDGE_CACHE_CONNECT
    }
  };
  EventEmitter.getInstance().dispatch(event);
};
export default sendEdgeCacheFailureDiagnostic;
